import { Actions } from "@Context/common/general/context";
import { useApi, useGlobalContext } from "@hooks/index";
import { Api } from "@Shared/schemas";
import { PlaylistResponse } from "@Shared/schemas/playlists/playlistSchemas";
import { useState } from "react";
import { useMount } from "react-use";

const usePlaylistsData = () => {
  const { globalState, dispatch } = useGlobalContext();
  const [loading, setLoading] = useState(true);
  const [playlists, setPlaylists] = useState<PlaylistResponse[] | null>(null);

  const { call: getPlaylists } = useApi<typeof Api.Playlists.GetPlaylists>({
    api: Api.Playlists.GetPlaylists,
    request: {
      // @ts-ignore
      account_id: globalState.account.id!,
      shared_with_user_ids: globalState.user.dbId ? [globalState.user.dbId] : [],
      exclude_tags: globalState.user.isSuperAdmin ? [] : ["QA", "DEVELOPMENT"],
      unpublished_allowed: globalState.user.isSuperAdmin ? true : false,
    },
    onSuccess: (response: { code: string; data: PlaylistResponse[] }) => {
      if (response.code !== "ok") return;
      setPlaylists(response.data);
      setLoading(false);
    },
  });

  useMount(() => {
    dispatch({
      type: Actions.ProgressionActions.GetProgressionConfig,
      payload: {
        cache_time: [60, "mins"],
        session_only: true,
        disableLoaders: true,
      },
    });
    getPlaylists();
  });

  return { playlists, loading };
};

export default usePlaylistsData;
